import { Flex, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaSave } from 'react-icons/fa'
import Modal from 'react-modal'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { FindUser } from '../../../../components/FindBox'
import { ModalBase } from '../../../../components/ModalBase'
import { iNomeId } from '../../../../interfaces'
import { appApi } from '../../../../services/appApi'

interface props {
  isOpen: boolean
  onRequestClose: () => void
  colaboradorId: string
  onConfirm: () => void
}

export const ModalChangeResponsavel: React.FC<props> = ({ isOpen, onRequestClose, onConfirm, colaboradorId }) => {
  Modal.setAppElement('#root')
  const [ResponsavelId, setResponsavelId] = useState<string>()
  const [Gestores, setGestores] = useState<iNomeId[]>([])

  function GetGestores(): void {
    appApi.get('Colaborador/Gestores')
      .then((res) => setGestores(res.data))
      .catch((err) => console.log(err))
  }

  function UpdateGestor(): void {
    appApi.patch(`Colaborador/${colaboradorId}/Gestor/${ResponsavelId}`)
      .then(() => onConfirm())
      .catch((err) => console.log(err))
  }

  useEffect(() => {
    GetGestores()
  }, [])

  return (
        <ModalBase
            isOpen={isOpen}
            onClose={onRequestClose}
            Titulo='Atualizar responsável do participante'
            Width='40rem'
        >
            <Flex flexDir={'column'} gap={'1rem'} px={'1rem'} pb={'2rem'}>
              <Flex flexDir={'column'} gap={'.325rem'} w={'full'}>
                <Text fontWeight={'500'} fontSize={'.875rem'} color={'var(--Gray1)'}>Novo responsável</Text>
                <FindUser
                  lista={Gestores.filter(e => colaboradorId !== e.id)}
                  onChoice={setResponsavelId}
                  selecionado={ResponsavelId}
                  placeholder='Digite o nome do novo responsável'
                />
              </Flex>
            </Flex>
            <Flex gap={'.5rem'} justifyContent={'end'} px={'1rem'} pt={'1rem'} pb={'1.25rem'}>
                <ButtonCmp VarColor='c6' onClick={onRequestClose}>Cancelar</ButtonCmp>
                <ButtonCmp VarColor='Green2' onClick={() => UpdateGestor()} leftIcon={<FaSave/>}>Salvar</ButtonCmp>
            </Flex>

        </ModalBase>
  )
}
